import keyMirror from 'keymirror';

export const sidebarActionTypes = keyMirror({
	GET_USER_DATA_REQUEST: null,
	GET_USER_DATA_SUCCESS: null,
	GET_USER_DATA_ERROR: null,
	SET_EXPANDED_MENU: null,
	LOGOUT: null,
	CLEAR_USER_DATA: null,
	SET_NOTIFICATION_COUNT: null,
	GET_COUNTRIES_REQUEST: null,
	GET_COUNTRIES_SUCCESS: null,
	GET_COUNTRIES_ERROR: null,
	SET_COUNTRY_OPTION_CODE: null,
	SET_COUNTRY_OPTION: null,
	UPDATE_USER_LOCALE: null,
	UPDATE_USER_THEME: null,
	SET_COUNTRY: null,
	GET_MENU_MADE_LISTS_REQUEST: null,
	GET_MENU_MADE_LISTS_SUCCESS: null,
	GET_MENU_MADE_LISTS_ERROR: null,
});

export const MIN_DESKTOP_WIDTH = 1024;

export const MIN_SUGGESTED_SUBJECTS = 5;
export const DESKTOP_SUGGESTED_SUBJECTS_LIMIT = 6;

// prettier-ignore
export const getSuggestedSubjects = (primarySubjects = [], defaultSubjects = [], limit) => {
	const listLimit = limit || MIN_SUGGESTED_SUBJECTS;
	const filteredPrimarySubjects = primarySubjects.filter((subject) => subject.active);
	const defaultIfNoPrimaryActive =
		primarySubjects.length >= listLimit
			? primarySubjects.slice(0, listLimit)
			: [
				...primarySubjects,
				...defaultSubjects.slice(0, listLimit - primarySubjects.length),
			];

	return filteredPrimarySubjects.length >= listLimit
		? filteredPrimarySubjects
		: defaultIfNoPrimaryActive;
};

export const getPracticableOptions = (sections, t) => {
	const tabs = sections.reduce((acc, section, index) => {
		const { type, hide } = section || {};
		if (!hide)
			acc.push({
				title: t(`sidebar.${type}_btn`),
				value: type,
				index,
			});

		return acc;
	}, []);
	if (tabs.length < 2) return [];
	return tabs;
};
